var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#C3B9D2",
    fillOpacity: 0.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    stroke: "#C3B9D2",
    strokeOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.82979C8.07459 7.7795 9.56643 6 12.0839 6C14.4895 6 16 7.52805 16 9.69439C16 12.4797 12.8298 12.7505 12.8298 15.0909V15.8066C12.8298 15.942 12.7739 16 12.6434 16H11.4499C11.3193 16 11.2634 15.942 11.2634 15.8066V15.2263C11.2634 12.1509 14.4336 11.8221 14.4336 9.71373C14.4336 8.35977 13.5012 7.54739 12.0839 7.54739C10.7786 7.54739 9.71562 8.32108 9.52914 9.82979C9.51049 9.96518 9.47319 10.0232 9.34266 10.0232H8.18648C8.05594 10.0232 8 9.96518 8 9.82979ZM11.2 17H12.8C12.94 17 13 17.06 13 17.2V18.8C13 18.94 12.94 19 12.8 19H11.2C11.06 19 11 18.94 11 18.8V17.2C11 17.06 11.06 17 11.2 17Z",
    fill: "#C3B9D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    stroke: "#C3B9D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.8c179fddc12bd60273bb3965ca1ea449.svg";
export { ForwardRef as ReactComponent };